import React from 'react';

const PaymentSecurity = () => {
    return (
        <div className="w-full h-screen p-4">
            <iframe
                src="https://esti.kz/esti_terms.pdf"
                className="w-full h-full border rounded-xl"
                title="PDF Viewer"
            />
        </div>
    );
};

export default PaymentSecurity;